/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If this component does not
 * do what you need it to, please reach out to a frontend
 * engineer before creating a new component or making
 * unapproved changes to this file.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import TableData from './data';
import styles from './table.scss';

export type TableHeadingPropTypes = React.BaseHTMLAttributes<HTMLTableCellElement>;

function TableHeading({
  className = '',
  children,
  ...props
}: TableHeadingPropTypes) {
  return (
    <TableData
      tag="th"
      data-qa-ref="table-head-data"
      className={classnames(styles.tableHeading, className)}
      {...props}
    >
      {children}
    </TableData>
  );
}

export default TableHeading;
